import { defineMessage } from '@atlassian/jira-intl';

const allChangesMessage = defineMessage({
	id: 'operations.changes.defaultFilters.all',
	defaultMessage: 'All',
	description:
		'Label for the default filter showing all changes in the changes sidebar navigation.',
});

const openChangesMessage = defineMessage({
	id: 'operations.changes.defaultFilters.open',
	defaultMessage: 'Open',
	description:
		'Label for the default filter showing open changes in the changes sidebar navigation.',
});

const closedChangesMessage = defineMessage({
	id: 'operations.changes.defaultFilters.closed',
	defaultMessage: 'Closed',
	description:
		'Label for the default filter showing closed changes in the changes sidebar navigation.',
});

const defaultFilters: Array<{
	id: string;
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	changeSearchQuery: string;
}> = [
	{
		id: 'all',
		label: allChangesMessage,
		changeSearchQuery: '',
	},
	{
		id: 'open',
		label: openChangesMessage,
		changeSearchQuery: 'resolution = Unresolved',
	},
	{
		id: 'closed',
		label: closedChangesMessage,
		changeSearchQuery: 'resolution = Done',
	},
];

export default defaultFilters;
